module.exports = __webpack_public_path__ + "static/media/TrashTransparent.a0a97e02.svg";